import { gridSizeConst1, gridSizeConst11, gridSizeMdLg12, gridSizeMdLg4, gridSizeMdLg8 } from "@/shared";
import { CustomTextFieldNoForm } from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { UpdateHistoryProspectoCorporativo } from "@/shared/interfaces";
import { Button, Grid, IconButton, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import SendIcon from '@mui/icons-material/Send';


interface HistorialActualizacionesProspecto {
    historyProspectoCorporativo: UpdateHistoryProspectoCorporativo[]
    handleOnSubmit?: (content:string)=>void
}
export default function HistorialActualizacionesProspecto({
    historyProspectoCorporativo,
    handleOnSubmit
}:HistorialActualizacionesProspecto) {
    const [OpenModal, setOpenModal] = useState(false);
    const [content, setContent] = useState<string>("")
    const contentUpdates = useRef<HTMLDivElement>(null)


    const handleSubmit = (time?:number) => {
        const container = contentUpdates.current;
        setTimeout(() => {
            if (container) {
              container.scrollTo({
                top: container.scrollHeight,
                behavior: 'smooth',
              });
            }
        }, time || 2000);
    };
    useEffect(() => {
        if(OpenModal){
            setTimeout(() => {
                handleSubmit(1)
            }, 500);
        }
    }, [OpenModal]);
  return (
    <>
    <Grid container item {...gridSizeMdLg12}>
        <Button color="primary" fullWidth variant="contained" onClick={()=>setOpenModal(true)}>
            Historial de Actualizaciones
        </Button>
        {
            OpenModal && (
                <ScrollableDialogProps
                title="Revisar Historial de Actualizaciones"
                open={OpenModal}
                onClose={()=>setOpenModal(false)}
                contentNode={
                    <>
                        <Grid container item {...gridSizeMdLg12}>
                            <Grid ref={contentUpdates} container boxShadow={10} textAlign={"center"} 
                            {...gridSizeMdLg12} sx={{ height: 300, overflowY:"auto" }}>
                                {
                                    historyProspectoCorporativo.length>0?
                                        historyProspectoCorporativo?.map((item, index)=>
                                            <ContentUpdate data={item} index={index}/>
                                        )
                                    : <Grid container item {...gridSizeMdLg12} justifyContent={"center"} 
                                        boxShadow={10} padding={2}>
                                        <Typography variant="h6" color={"GrayText"} textAlign={"center"}>
                                            Aún no hay actualizaciones.
                                        </Typography>
                                    </Grid>
                                }
                            </Grid>
                            <Grid item container {...gridSizeMdLg12} sx={{ paddingY: 2 }}>
                                <Grid item container {...gridSizeConst11}>
                                    <CustomTextFieldNoForm
                                        label="Agregar actualización"
                                        variant="outlined"
                                        sxTextField={{ textAlign:"end"}}
                                        size={gridSizeMdLg12}
                                        value={content}
                                        actionEnter={(e)=>{
                                            if(e.key==="Enter"){
                                                ((content.trim()).length)>5 && handleOnSubmit && handleOnSubmit(content)
                                            }
                                            setContent("")
                                            handleSubmit()
                                            e.preventDefault()
                                        }}
                                        onChangeCustom={(e)=>{
                                            setContent(e.target.value)
                                        }}
                                    />
                                </Grid>
                                <Grid item {...gridSizeConst1} justifyContent={"center"} alignContent={"center"} textAlign={"center"} >
                                    <IconButton color="primary" onClick={()=>{
                                        ((content.trim()).length)>5 && handleOnSubmit && handleOnSubmit(content)
                                        setContent("")
                                        handleSubmit()
                                    }}>
                                        <SendIcon/>
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                }
                />
            )
        }

    </Grid>
    </>
    
  )
}



function ContentUpdate({
    data, 
    index
} : {data:UpdateHistoryProspectoCorporativo, index:number}) {
    return (
        <Grid key={`card-content-update-${index}}`} container item {...gridSizeMdLg12} 
        sx={{padding:2, boxShadow:2, margin:2, border:1, borderColor:"#c0c0c2"}} height={150}>
            <Grid item container {...gridSizeMdLg12}>
                <Grid item container {...gridSizeMdLg8} textAlign={"start"}>
                    <Typography variant="h6" fontSize={15} color={"GrayText"}>
                        {data.date}
                    </Typography>
                </Grid>
                <Grid item container {...gridSizeMdLg4} justifyContent={"end"}>
                    <Typography variant="h6" fontSize={12} color={"black"}>
                        {data.created_by}
                    </Typography>
                </Grid>
            </Grid>
            <Grid item container {...gridSizeMdLg12} sx={{ marginTop:1}}>
                <Typography variant="body1" color={"black"} textAlign={"start"} sx={{ overflowY:"auto", height:100 }}>
                    {data.content}
                </Typography>
            </Grid>
        </Grid>
    )
}
